<template>
  <master-layout id="gicContentSchedule">
    <div class="lg:w-full">
      <div v-if="type" class="lg:pb-[24px] md:bg-grey-5 lg:mx-auto">
        <!-- top banner section-->
        <div id="main-container" class="lg:bg-transparent lg:py-[35px]">
          <!--Schedule with Panzoom (pinch to zoom)-->
          <div
            class="lg:p-[22px] mx-auto lg:max-w-[800px] lg:justify-center lg:items-center lg:bg-transparent"
            :class="{ '!pt-[60px]': isIos, '!pt-[var(--safe-area-inset-top)]': isAndroid }"
          >
            <div class="flex flex-col">
              <ImageZoom
                ref="imageZoomRef"
                class=""
                :imageSrc="scheduleImage"
                :maxScale="3"
                :minScale="1"
              />
              <in-app-browser
                class="text-center align-center mx-auto p-4 aktiv-grotesk italic underline text-[#21252C]"
                :href="scheduleImage"
              >
                Click to download schedule
              </in-app-browser>
            </div>
          </div>
        </div>
      </div>
    </div>
  </master-layout>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import ImageZoom from '@/components/SchedulePage/ImageZoom.vue';
import { FirebaseAnalytics } from '@/utils/firebase-analytics-wrapper';
import platformMixin from '@/mixins/platformMixin';
import { CONFERENCE_TYPES } from '@/utils/conference-type';
import { App as CapApp } from '@capacitor/app';

export default {
  name: 'GICSchedulePage',
  mixins: [platformMixin],
  components: {
    ImageZoom,
  },
  data() {
    return {
      appStateListener: null,
    };
  },
  computed: {
    ...mapGetters('profile', ['type']),
    ...mapState('cms', ['gicScheduleImage']),
    scheduleImage() {
      return this.gicScheduleImage;
    },
  },
  async ionViewWillEnter() {
    await this.refreshGicScheduleData();
  },
  async ionViewDidEnter() {
    if (this.appStateListener) {
      await this.appStateListener.remove();
      this.appStateListener = null;
    }
    this.appStateListener = await CapApp.addListener('appStateChange', async ({ isActive }) => {
      if (isActive) {
        await this.refreshGicScheduleData();
      }
    });

    FirebaseAnalytics.setScreenName({
      screenName: 'schedule',
      nameOverride: 'SchedulePage',
    });
    this.$refs.imageZoomRef?.startDismissTimer();
  },
  async ionViewDidLeave() {
    if (this.appStateListener) {
      await this.appStateListener.remove();
      this.appStateListener = null;
    }
  },
  methods: {
    async refreshGicScheduleData() {
      await Promise.all([
        this.$store.dispatch('profile/forceFetchProfile'),
        this.$store.dispatch('cms/fetchGicScheduleImage'),
        this.$store.dispatch('cms/fetchAnnouncements', {
          locale: 'en',
          conferenceType: CONFERENCE_TYPES.GIC,
          force: true,
        }),
        this.$store.dispatch('announcements/fetchUnreadCount', CONFERENCE_TYPES.GIC),
      ]);
    },
  },
};
</script>
